import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import LiteratureContent from './Literature';
import JournalContent from './Journal';
import TierContent from './Tier';
const TextualContent = (props)=>{
    const deviationType = getDeviationType(props.deviation);
    switch(deviationType){
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(LiteratureContent, _extends({}, props));
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalContent, _extends({}, props));
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierContent, _extends({}, props));
        default:
    }
    return null;
};
TextualContent.displayName = 'TextualContent';
export default TextualContent;
